import _ from "lodash";
import moment from "moment";
import React from "react";
import Chart from "../../../../parts/chart";
import { DATE_FORMATS, WEIGHT_UNITS } from "../../../../constants";
import {
  filterExercisesByDateRange,
  convertOutcomeE1rmAndLoads,
  groupExercisesByDay,
  getVolumePerDay,
} from "../../../../utils/workout-stats";
import EmptyStatementMsg from "./EmptyStatementMsg";

const VolumeHistoryChart = ({
  date,
  activeDayUtc,
  exercises,
  units,
  height = "400px",
  daysBack = 7,
}) => {
  const startUtc = Number(
    moment(date, DATE_FORMATS.DATE_DAY_FORMAT)
      .subtract(daysBack - 1, "day")
      .format(DATE_FORMATS.UTC)
  );

  const filteredExercises = filterExercisesByDateRange({
    exercises:
      units === "imperial" ? convertOutcomeE1rmAndLoads(exercises) : exercises,
    startUtc,
    endUtc: activeDayUtc,
  });
  const groupedExercises = groupExercisesByDay(filteredExercises);
  let volumePerDayData = getVolumePerDay({ exercisesDays: groupedExercises });
  _.reverse(volumePerDayData);
  volumePerDayData = _.filter(
    volumePerDayData,
    (val) => val.volume && Number.isFinite(val.volume)
  );
  const volumePerDaySeries = [
    {
      name: "Last 7 days volume",
      className: "",
      data: volumePerDayData.map((volData) => volData.volume),
    },
  ];
  const volumePerDayLabels = volumePerDayData.map((volData) =>
    moment
      .utc(volData.utcDate, DATE_FORMATS.UTC)
      .format(DATE_FORMATS.DATE_PICKER_FORMAT)
  );
  return _.isEmpty(volumePerDaySeries[0].data) ? (
    <EmptyStatementMsg message="No data to show" />
  ) : (
    <div className="graph body">
      <Chart
        type="Bar"
        data={{
          labels: volumePerDayLabels,
          series: volumePerDaySeries,
        }}
        options={{
          height: height,
          axisX: { showGrid: false },
          axisY: { onlyInteger: true },
        }}
        tooltip={(item, i) => {
          const vol = volumePerDaySeries[0].data[i];
          const tooltipDate = volumePerDayLabels[i];
          return (
            <div className="tooltip" style={{ left: item.x + 14 }}>
              <div className="details">
                <div>
                  <b>
                    {vol} {_.capitalize(WEIGHT_UNITS[units])}
                  </b>
                </div>
                <div>{tooltipDate}</div>
              </div>
            </div>
          );
        }}
      />
    </div>
  );
};

export default VolumeHistoryChart;
